const APP_VERSION = "0.19.7"; module.exports = { APP_VERSION };
